import { inspectionClient } from '@/config/api';

interface DocumentMetadata {
  documentId: string;
  entityId: string;
  documentType: string;
  documentName: string;
  presignedUrl: string;
  creationDate: string;
  metadata?: Record<string, any>;
}

interface UploadResult {
  documentId: string;
  fileSizeBytes: number;
}

class DocmanService {
  async uploadFile(
    entityId: string,
    file: File,
    documentType: string = 'inspection_attachment',
    _metadata?: Record<string, any>,
  ): Promise<{ documentId: string; presignedUrl: string }> {
    const formData = new FormData();
    formData.append('entityId', entityId);
    formData.append('file', file);
    formData.append('documentType', documentType);

    const response = await inspectionClient.post<UploadResult>(
      '/api/docman/upload',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );

    return { documentId: response.data.documentId, presignedUrl: '' };
  }

  async listDocuments(entityId: string): Promise<DocumentMetadata[]> {
    const response = await inspectionClient.get<DocumentMetadata[]>(
      `/api/docman/entities/${entityId}/documents`,
    );
    return response.data;
  }

  async getDocument(
    documentId: string,
    _entityId?: string,
    _documentType?: string,
    _documentName?: string,
  ): Promise<DocumentMetadata> {
    const response = await inspectionClient.get<DocumentMetadata>(
      `/api/docman/document/${documentId}`,
    );
    return response.data;
  }

  async getImageUrl(documentId: string): Promise<string> {
    const response = await inspectionClient.get<{ presignedUrl: string }>(
      `/api/docman/document/${documentId}/url`,
    );
    return response.data.presignedUrl;
  }

  async downloadFile(documentId: string): Promise<Blob> {
    const response = await inspectionClient.get(
      `/api/docman/document/${documentId}/download`,
      { responseType: 'blob' },
    );
    return response.data as Blob;
  }

  clearCache(): void {
    // No-op: arquitetura atual não mantém cache no front (token vive no backend).
    // Mantido por compatibilidade com auth.service.ts que chama no logout.
  }
}

export const docmanService = new DocmanService();
export type { DocumentMetadata };
